import { Pipe, PipeTransform } from '@angular/core';
import { Beneficjent } from '../../models/beneficjent';
import { FormControl, Validators } from '@angular/forms';
import { SharedValidators } from '../../validators/shared-validators';

@Pipe({
  name: 'userEmailValidPipe',
})
export class UserEmailValidPipe implements PipeTransform {
  transform(beneficjent?: Beneficjent): boolean {
    const control = new FormControl(beneficjent?.email, [
      Validators.required,
      SharedValidators.doNotBeginWithWhitespace(),
      SharedValidators.emailValidator(),
    ]);
    control.updateValueAndValidity();
    return control.valid;
  }
}
